const washingmachine = `Asunto: Solicitud de reparación urgente para lavadora
Estimado administrador de la propiedad
Le escribo para informar de un problema con la lavadora de mi apartamento.
La máquina pierde agua y no completa el ciclo de lavado correctamente, lo que causa muchos problemas.
Me preocupa que el agua pueda causar daños al apartamento si no se repara rápidamente.
Es importante repararlo lo antes posible para evitar más problemas.
También tengo un montón de ropa que necesito lavar.
Envía a alguien a arreglar la lavadora tan pronto como puedas.
Agradezco su pronta atención a este asunto.
Gracias.
Sinceramente, `;

export default washingmachine;